import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { makeDataLocationPath } from '@integration-app/sdk';
import { toHeaderCase } from 'js-convert-case';
import { Properties, Property } from '../Row/Properties';
export function FieldPropertiesList({ propertiesSchema, properties, isRequired, }) {
    var _a;
    const activeProperties = Object.keys((_a = propertiesSchema.properties) !== null && _a !== void 0 ? _a : {})
        .filter((key) => !!(properties === null || properties === void 0 ? void 0 : properties[key]))
        .map((key) => ({
        name: toHeaderCase(key),
        value: getPropertyValueString(key, properties === null || properties === void 0 ? void 0 : properties[key]),
    }));
    if (isRequired) {
        activeProperties.push({
            name: 'Required',
            value: 'yes',
        });
    }
    return activeProperties.length ? (_jsx(Properties, { children: activeProperties.map((property, i) => (_jsxs(Property, { children: [_jsxs(Property.Name, { children: [property.name, property.value && ':'] }), property.value && (_jsxs(Property.Value, { children: [property.value.substring(0, 50), property.value.length > 50 ? '...' : ''] }))] }, i))) })) : null;
}
function getPropertyValueString(propertyKey, value) {
    var _a;
    switch (propertyKey) {
        case 'referenceCollection':
            return (_a = makeDataLocationPath(value)) === null || _a === void 0 ? void 0 : _a.replace('/data/', '');
        case 'referenceRecords':
            return `${value === null || value === void 0 ? void 0 : value.length} items`;
        default:
            return value === null || value === void 0 ? void 0 : value.toString();
    }
}
//# sourceMappingURL=PropertiesList.js.map